import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import FETCH from '../Fetch';
import { numberFormat } from '../utils';
import FeeDetailsLoader from '../loaderComponents/FeeDetailsLoader';
import { toast } from './Notifier';

function EmptyFees({ message }) {
  return (
    <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
      <h1>Error</h1>
      <div className="row no-gutters">
        <div className="col-lg-12 m-auto">
          <div className="card ">
            <div className="card-body">
              <div className="dashboard-transaction-container text-center">
                <div className="empty-card text-center mt-3">
                  <button className="circle-bg-width-80 circle-bg circle-bg-gray">
                    <img
                      src={require('../assets/empty-fee.svg')}
                      className="svg"
                      alt="Min Unit"
                    />
                  </button>

                  <Fragment>
                    <p>Sorry</p>
                    <small>{message}</small>
                  </Fragment>
                </div>
                <Fragment>
                  <Link
                    className="btn btn-primary btn-primary-color  mt-5"
                    to="/fees"
                  >
                    Back
                  </Link>
                </Fragment>
              </div>
            </div>
          </div>
          {/* card for outstanding fees */}
        </div>
      </div>

      {/* end card for news display   */}
    </main>
  );
}

class FeeDetails extends React.Component {
  state = {
    paymentDetails: null,
    splitPayment: null,
    paymentMethod: 'online',
    cardType: 'mastercard',
    loading: true,
    isGeneratingRRR: false,
    rrrIsGenerated: false,
    cannotMakePayment: false,
    cannotGetFeeDetails: false,
    responseTimeout: 10000,
    responseTimeoutMessage: 'The payment channel is taking too long to respond',
    hasResponded: false
  };

  componentDidMount() {
    // get fee id from path
    const {
      match: {
        params: { id }
      }
    } = this.props;

    // start reponse time interval check
    this.setResponseTimeout();

    // fetch payment details with fee id
    FETCH.getFeeDetails(id)
      .then(response => {
        this.clearResponseTimeout()
        if (response.status === 'error') {
          this.setState({ cannotGetFeeDetails: true, loading: false });
          return;
        }
        const {
          data: { paymentDetails, splitPayment }
        } = response;
        const isRemita = splitPayment.payment_channel === 'remita';

        if (splitPayment.message) {
          toast(splitPayment.message, { status: 'error' });
          return this.setState({
            paymentDetails,
            cannotMakePayment: true,
            errorMessage: splitPayment.message,
            splitPayment,
            isRemita,
            loading: false,
            hasResponded: true
          });
        }
        if (isRemita) {
          if (splitPayment.message || !splitPayment.rrr) {
            this.setState({
              paymentDetails,
              cannotMakePayment: true,
              errorMessage: splitPayment.message,
              splitPayment,
              isRemita,
              loading: false,
              hasResponded: true
            });
            if (splitPayment.message)
              toast(splitPayment.message, { status: 'error', timeout: 6000 });
            return;
          }
          this.setState({
            paymentDetails,
            splitPayment,
            loading: false,
            isRemita,
            hasResponded: true
          });
        } else {
          const noPaymentUrl = splitPayment.payment_url === null;
          this.setState({
            paymentDetails,
            splitPayment,
            isRemita,
            cannotMakePayment: noPaymentUrl,
            loading: false,
            hasResponded: true
          });
        }
      })
      .catch(error => {
        this.setState({ loading: false, hasResponded: true });
        this.clearResponseTimeout();
        toast(error.message, { status: error });
      });
  }

  componentWillUnmount() {
    this.clearResponseTimeout();
  }

  setResponseTimeout = () => {
    this.timeout = setInterval(() => {
      const { hasResponded, responseTimeoutMessage } = this.state;
      // clear interval if network response has been received
      if (hasResponded) return;
      this.clearResponseTimeout();
      toast(responseTimeoutMessage, { status: 'error' });
    }, this.state.responseTimeout);
  };

  clearResponseTimeout = () => {
    // clear response time interval
    
    clearInterval(this.timeout);
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  generateRRR = () => {
    // if (this.state.cannotMakePayment) return;
    // start generating rrr to display rrr generation loader
    this.setState({ isGeneratingRRR: true });

    this.updateFee()
      .then(res => {
        if (res.status === 'success') {
          this.setState({ isGeneratingRRR: false, rrrIsGenerated: true });
          toast(
            'RRR is successfully generated, you can proceed to the bank to make payments',
            { status: 'success' }
          );
          return;
        }
        return toast(
          "RRR couldn't be generated at this time try again later!!!",
          { status: 'error' }
        );
      })
      .catch(error =>
        toast("RRR couldn't be generated, check network connectivity", {
          status: 'error'
        })
      );
  };

  updateFee = () => {
    // update the fee || save transaction data to database
    const data = {
      trans_ref: this.state.splitPayment.order_id,
      payment_code: this.state.paymentDetails.payment_id,
      payment_id: this.state.paymentDetails.id,
      rrr_code: this.state.splitPayment.rrr || null,
      payment_url: this.state.splitPayment.payment_url || null
    };

    return FETCH.UpdateFee(data).then(response => {
      if (!this.state.isRemita)
        return (window.location.href = this.state.splitPayment.payment_url);
      return response;
    });
  };

  makePayment = () => {
    if (this.state.errorMessage) return;
    this.updateFee().then(response => {
      if (response.status === 'success') return this.makePaymentForm.submit();
    });
  };

  render() {
    const {
      cannotMakePayment,
      cannotGetFeeDetails,
      isRemita,
      splitPayment
    } = this.state;

    return (
      <Fragment>
        {cannotGetFeeDetails ? (
          <EmptyFees message="Cannot get fee details" />
        ) : (
          <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
            {/* main content area */}
            <Link to="/fees">
              <h1 className="small">
                <i className="fas fa-arrow-left" />
                My fees
              </h1>
            </Link>
            {this.state.loading ? (
              <FeeDetailsLoader />
            ) : (
              <Fragment>
                {/* card for registered courses display  */}
                <div className="row no-gutters">
                  <div className="col-lg-12">
                    <div className="card">
                      <div className="card-header">
                        <div className="row no-gutters">
                          <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 p-2">
                            Make Payment
                          </div>
                        </div>
                      </div>
                      <div className="card-body p-0">
                        <div className="row m-0">
                          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-5 order-2 order-sm-2 order-md-2 order-lg-1 order-xl-1 p-0 border-right">
                            <div
                              className={`payment-details ${!isRemita &&
                                'mt-5'}`}
                            >
                              <div className="detail-container">
                                <p className="text">You are paying</p>
                                <div className="amount">
                                  {numberFormat(
                                    this.state.paymentDetails.total -
                                      this.state.paymentDetails.penalty_fee
                                  )}{' '}
                                  <span>NGN</span>
                                </div>
                              </div>
                              <hr className="separator" />
                              {!isRemita ? (
                                ''
                              ) : (
                                <div className="detail-container">
                                  <p className="text">Payment Method</p>
                                  <select
                                    className="long w-100 mt-3"
                                    onChange={this.handleChange}
                                    name="paymentMethod"
                                  >
                                    <option value="online">
                                      Online Payment
                                    </option>
                                    <option value="bank">Bank Payment</option>
                                  </select>
                                </div>
                              )}
                              {!isRemita ? (
                                ''
                              ) : this.state.paymentMethod === 'online' ? (
                                <Fragment>
                                  <hr className="separator" />
                                  <div className="detail-container">
                                    <p className="text">Card Type</p>
                                    <select
                                      className="long w-100 mt-3"
                                      onChange={this.handleChange}
                                      name="cardType"
                                    >
                                      <option value="mastercard">
                                        Mastercard
                                      </option>
                                      <option value="visa">Visa</option>
                                    </select>
                                  </div>
                                </Fragment>
                              ) : (
                                <Fragment>
                                  <div className="detail-container">
                                    {this.state.isGeneratingRRR ? (
                                      <span className="btn w-100 mt-5 btn-primary btn-primary-color text-left">
                                        Generating RRR Code...{' '}
                                        <i className="fas fa-circle-notch fa-spin ml-5" />
                                      </span>
                                    ) : (
                                      <Fragment>
                                        {this.state.rrrIsGenerated ? (
                                          <span className="btn w-100 mt-3 generated-rrr">
                                            {this.state.splitPayment.rrr}
                                          </span>
                                        ) : (
                                          <span className="btn w-100 mt-5  text-left" />
                                        )}
                                      </Fragment>
                                    )}
                                  </div>
                                </Fragment>
                              )}
                            </div>
                            {/* button */}
                            <div className={`footer ${!isRemita && 'mt-5'}`}>
                              {/* subtitute active class for disabled to either make button active or inactive */}
                              {!isRemita ? (
                                <button
                                  className={`position-relative btn w-100 btn-primary-big btn-border-radius-payment active mt-5 ${
                                    this.state.cannotMakePayment
                                      ? 'disabled'
                                      : ''
                                  }`}
                                  disabled={cannotMakePayment ? true : false}
                                  onClick={this.updateFee}
                                >
                                  {splitPayment.channel_name
                                    ? `Continue to ${splitPayment.channel_name}`
                                    : 'Continue'}
                                </button>
                              ) : this.state.paymentMethod === 'online' ? (
                                <Fragment>
                                  {this.state.cannotMakePayment ? (
                                    <button
                                      className={`position-relative btn w-100 btn-primary-big btn-border-radius-payment active ${
                                        this.state.cannotMakePayment
                                          ? 'disabled'
                                          : ''
                                      }`}
                                      disabled={
                                        cannotMakePayment ? true : false
                                      }
                                    >
                                      Make Payment
                                    </button>
                                  ) : (
                                    <Fragment>
                                      <form
                                        action={
                                          this.state.splitPayment.finalize_url
                                        }
                                        id="remita_form"
                                        name="remita_form"
                                        method="POST"
                                        ref={el => (this.makePaymentForm = el)}
                                      >
                                        <input
                                          id="merchantId"
                                          name="merchantId"
                                          defaultValue={
                                            this.state.splitPayment.merchant_id
                                          }
                                          type="hidden"
                                        />
                                        <input
                                          id="rrr"
                                          name="rrr"
                                          defaultValue={
                                            this.state.splitPayment.rrr
                                          }
                                          type="hidden"
                                        />
                                        <input
                                          id="responseurl"
                                          name="responseurl"
                                          defaultValue="{{data.responseurl}}"
                                          type="hidden"
                                        />
                                        <input
                                          id="hash"
                                          name="hash"
                                          defaultValue={
                                            this.state.splitPayment.hash
                                          }
                                          type="hidden"
                                        />
                                        <input
                                          id="paymenttype"
                                          name="paymenttype"
                                          defaultValue={
                                            this.state.paymentMethod
                                          }
                                          type="hidden"
                                        />
                                      </form>
                                      <button
                                        className={`position-relative btn w-100 btn-primary-big btn-border-radius-payment active ${
                                          this.state.cannotMakePayment
                                            ? 'disabled'
                                            : ''
                                        }`}
                                        onClick={this.makePayment}
                                      >
                                        Make Payment
                                      </button>
                                    </Fragment>
                                  )}
                                </Fragment>
                              ) : (
                                <Fragment>
                                  {this.state.rrrIsGenerated ? (
                                    <button className="position-relative btn w-100 btn-primary-big btn-border-radius-payment active">
                                      Print Payment Invoice
                                    </button>
                                  ) : (
                                    <button
                                      className={`position-relative btn w-100 btn-primary-big btn-border-radius-payment active ${
                                        this.state.cannotMakePayment
                                          ? 'disabled'
                                          : ''
                                      }`}
                                      onClick={() =>
                                        !this.state.cannotMakePayment &&
                                        this.generateRRR()
                                      }
                                    >
                                      Generate RRR Code
                                    </button>
                                  )}
                                </Fragment>
                              )}
                            </div>
                          </div>
                          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-7 order-1 order-sm-1 order-md-1 order-lg-2 order-xl-2  p-0">
                            <div className="payment-details">
                              <div className="row detail-container m-0">
                                <div className="col-lg-6 text">
                                  Payment Details
                                </div>
                                <div className="col-lg-6 text bold">
                                  {this.state.paymentDetails.description}
                                </div>
                              </div>
                              <hr className="separator" />
                              <div className="row detail-container m-0">
                                <div className="col-lg-6 text">Due Date</div>
                                <div className="col-lg-6 text bold">
                                  {this.state.paymentDetails.due_date}
                                </div>
                              </div>
                              <hr className="separator" />
                              <div className="row detail-container m-0">
                                <div className="col-lg-6 text">
                                  Transaction Ref.
                                </div>
                                <div className="col-lg-6 text bold">
                                  {`${
                                    this.state.splitPayment.order_id
                                      ? this.state.splitPayment.order_id
                                      : ''
                                  }`}
                                </div>
                              </div>
                              <hr className="separator" />
                              <div className="row detail-container m-0">
                                <div className="col-lg-6 text">
                                  Total Payment
                                </div>
                                <div className="col-lg-6 text bold">
                                  {`${numberFormat(
                                    this.state.paymentDetails.total
                                  )} NGN`}
                                </div>
                              </div>
                              <div className="row detail-container m-0">
                                <div className="col-lg-6 text-misc">
                                  School Fees
                                </div>
                                <div className="col-lg-6 text-misc">
                                  {`${numberFormat(
                                    this.state.paymentDetails.total -
                                      this.state.paymentDetails.penalty_fee
                                  )}`}{' '}
                                  NGN
                                </div>
                              </div>
                              <div className="row detail-container m-0">
                                <div className="col-lg-6 text-misc">
                                  {this.state.paymentDetails.penalty_fee
                                    ? 'Late Reg'
                                    : 'Other Charges'}
                                </div>
                                <div className="col-lg-6 text-misc">
                                  {`${numberFormat(
                                    this.state.paymentDetails.penalty_fee
                                  )}`}{' '}
                                  NGN
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* card for outstanding fees */}
                  </div>
                </div>
                {/* end card for news display   */}
              </Fragment>
            )}
          </main>
        )}

        {/* main content area */}
      </Fragment>
    );
  }
}

export default FeeDetails;
